import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { css } from '@emotion/react';

const commonRichTextStyles = css`
  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.link};
    }
  }

  button {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
    font-size: ${theme.typography.fontSize.display5};
    
    color: ${theme.colors.text.brand};
    background: none;
    border: none;
    padding: 0;
    outline: inherit;

    span {
      font-family: ${theme.typography.fontFamily.secondary};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.inverse}; 
      background-color: ${theme.colors.brand.primary};
      padding-left: ${theme.spacing.sm};
      padding-right: ${theme.spacing.sm};
      border-radius: 50%;
      cursor: pointer;
    }

    &:hover {
      span {
        background-color: ${theme.colors.text.linkHover};
      }
    }

    &:active {
      span {
        background-color: ${theme.colors.interactive.active};
      }
    }
  }
`;

export const AddressManualContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const AddressManualTitle = styled.h3`
  margin: 0;
  font-size: ${theme.typography.fontSize.h3};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  text-align: center;

  ${media.tablet`
    font-size: ${theme.typography.fontSize.h1};
  `}

  ${media.desktop`
    font-size: ${theme.typography.fontSize.h2};
  `}
`;

export const AddressManualDescription = styled.div`
  ${commonRichTextStyles}
  font-size: ${theme.typography.fontSize.h6};
  line-height: ${theme.typography.lineHeight.body1};
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.regular};
  text-align: center;
  margin-top: ${theme.spacing.md}; 
  margin-bottom: ${theme.spacing.xl};

   ${media.tablet`
    margin-top: ${theme.spacing.lg};
    margin-bottom: ${theme.spacing.xl};
  `}
   ${media.desktop`
    margin-top: ${theme.spacing.md}; 
    margin-bottom: ${theme.spacing.xl};
  `}
`;

export const AddressManualInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};

  & div {
    padding: 0;
  }
`;

export const ErrorMsg = styled.p`
  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
  color: ${theme.colors.text.error};
  font-size: ${theme.typography.fontSize.body3};
  line-height: ${theme.typography.lineHeight.body3};
  font-weight: ${theme.typography.fontWeight.regular};
  text-align: left;
`;

